import {types as AcademicTypes } from './modules/academic'
import {types as AgentUserTypes } from './modules/agentUser'
import {types as ClassroomTypes} from './modules/classroom'
import {types as LiveCourseTypes} from './modules/livecourse'
import {types as LoadingTypes} from './modules/loading'
import {types as OrderTypes} from './modules/order'
import {types as ShowworkTypes} from './modules/showwork'
import {types as TeamTypes} from './modules/team'
import {types as UserTypes} from './modules/user'
import {types as OrangeGoldTypes } from './modules/orangeGold'
import {types as BlockCourseTypes} from './modules/blockcourse'


export  {
    AcademicTypes,
    AgentUserTypes,
    ClassroomTypes,
    LiveCourseTypes,
    LoadingTypes,
    OrderTypes,
    ShowworkTypes,
    TeamTypes,
    UserTypes,
    OrangeGoldTypes,
    BlockCourseTypes,
}


